import { useFetcher } from '@remix-run/react';
import { useEffect, useState } from 'react';

const usePaginatedAuthorsPosts = ({ initialPosts, initialPagination, authorId }: any) => {
  const fetcher = useFetcher();
  const totalPages = initialPagination.total_pages;
  const [posts, setPosts] = useState(initialPosts);
  const [page, setPage] = useState(initialPagination.page);
  const fetchedData = fetcher?.data;

  const fetchPosts = () => {
    const searchParams: any = new URLSearchParams();
    searchParams.append('page', page + 1);
    searchParams.append('author_id', authorId);

    fetcher.load(`/paginated_author_posts?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (posts) {
      setPage(1);
      setPosts(initialPosts);
    }
  }, [initialPosts]);

  useEffect(() => {
    if (fetchedData) {
      setPage(page + 1);
      setPosts(posts.concat(fetchedData?.posts));
    }
  }, [fetchedData]);

  return {
    postsToRender: posts,
    showLoadMore: page + 1 <= totalPages,
    isLoading: fetcher?.state !== 'idle',
    postsFetcher: fetcher,
    fetchPosts,
  };
};

export default usePaginatedAuthorsPosts;
